import { FaCalendarAlt } from 'react-icons/fa';

const HeaderNotification = () => {
  // rendering header notification component here
  return (
    <li className='flex gap-2 px-3 py-2 cursor-pointer hover:bg-gray-200 duration-300'>
      <div>
        <FaCalendarAlt className='h-full w-8 text-base-cyan' />
      </div>

      <div>
        <h2 className='font-medium text-base-cyan'>Appointment Reminder</h2>
        <p className='w-4/5 text-sm truncate'>
          You have an appointment with Mr. XYZ sdasdjdhvsdjhfjdh
        </p>
      </div>
    </li>
  );
};

export default HeaderNotification;
